// Calculation documented here: https://getsquareone.atlassian.net/wiki/spaces/SP/pages/369459251/Calculation+of+billing+payment+and+settled+amount
import {
  IEmergePayTransaction,
  ProcessingFeeHandlingTypeEnum
} from '@/services/types/TransactionData';

export const getBillingAmount = (transactionData: IEmergePayTransaction) => {
  switch (transactionData.processingFeeHandlingType) {
    case ProcessingFeeHandlingTypeEnum.Customer: {
      return transactionData.amount;
    }
    case ProcessingFeeHandlingTypeEnum.Merchant: {
      return transactionData.amount + transactionData.processingFee;
    }
  }
};

export const getPaymentAmount = (transactionData: IEmergePayTransaction) => {
  switch (transactionData.processingFeeHandlingType) {
    case ProcessingFeeHandlingTypeEnum.Customer: {
      return transactionData.amount + transactionData.processingFee;
    }
    case ProcessingFeeHandlingTypeEnum.Merchant: {
      return transactionData.amount;
    }
  }
};

export const getFeeResponsibilityDisplay = (transactionData: IEmergePayTransaction) => {
  switch (transactionData.processingFeeHandlingType) {
    case ProcessingFeeHandlingTypeEnum.Customer:
      return 'Customer';
    case ProcessingFeeHandlingTypeEnum.Merchant:
      return 'Business';
  }
};
